<template>
  <div class="notice_mng">
    <h2 class="title_com">日报详情</h2>
    <section class="pd2430">
      <el-form :model="formData" ref="form" v-if="!loading">
        <h3 class="daily-title">
          {{ dailyTitle }}
        </h3>
        <table class="table-body">
          <thead>
            <tr>
              <th colspan="9">
                <div class="table-flex">
                  <p class="table-text-1">记录人：{{ recordPeople }}</p>
                  <p class="table-text-1">记录日期：{{ recordDate }}</p>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td :rowspan="formData.schedule_info.list.length + 1" class="table-label">
                课程信息
              </td>
              <td colspan="4" class="table-label">课程名称</td>
              <td class="table-label">授课专家</td>
              <td class="table-label">地点</td>
              <td colspan="2" class="table-label">时间</td>
            </tr>
            <tr v-for="(item, index) in formData.schedule_info.list" :key="index">
              <td colspan="4">{{ item.title }}</td>
              <td>{{ item.experts_name }}</td>
              <td :rowspan="formData.schedule_info.list.length" v-if="index == 0">
                {{ formData.schedule_info.address }}
              </td>
              <td colspan="2">{{ item.time }}</td>
            </tr>
            <tr>
              <td rowspan="3" class="table-label">考勤情况</td>
              <td class="table-label">上午应到</td>
              <td class="table-statistics">
                <div class="table-statistics-box">
                  <div class="table-statistics-value">
                    {{ formData.sign.am.should_count }}
                  </div>
                  <div class="table-statistics-label">人</div>
                </div>
              </td>
              <td class="table-label">上午实到</td>
              <td class="table-statistics">
                <div class="table-statistics-box">
                  <div class="table-statistics-value">{{ formData.sign.am.ct_num }}</div>
                  <div class="table-statistics-label">人</div>
                </div>
              </td>
              <td class="table-label">上午迟到</td>
              <td class="table-statistics">
                <div class="table-statistics-box">
                  <div class="table-statistics-value">
                    {{ formData.sign.am.late_num }}
                  </div>
                  <div class="table-statistics-label">人</div>
                </div>
              </td>
              <td class="table-label">上午请假</td>
              <td class="table-statistics">
                <div class="table-statistics-box">
                  <div class="table-statistics-value">
                    {{ formData.sign.am.leave_num }}
                  </div>
                  <div class="table-statistics-label">人</div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="table-label">下午应到</td>
              <td class="table-statistics">
                <div class="table-statistics-box">
                  <div class="table-statistics-value">
                    {{ formData.sign.pm.should_count }}
                  </div>
                  <div class="table-statistics-label">人</div>
                </div>
              </td>
              <td class="table-label">下午实到</td>
              <td class="table-statistics">
                <div class="table-statistics-box">
                  <div class="table-statistics-value">{{ formData.sign.pm.ct_num }}</div>
                  <div class="table-statistics-label">人</div>
                </div>
              </td>
              <td class="table-label">下午迟到</td>
              <td class="table-statistics">
                <div class="table-statistics-box">
                  <div class="table-statistics-value">
                    {{ formData.sign.pm.late_num }}
                  </div>
                  <div class="table-statistics-label">人</div>
                </div>
              </td>
              <td class="table-label">下午请假</td>
              <td class="table-statistics">
                <div class="table-statistics-box">
                  <div class="table-statistics-value">
                    {{ formData.sign.pm.leave_num }}
                  </div>
                  <div class="table-statistics-label">人</div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="8" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.sign.out_user"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td rowspan="5" class="table-label">课堂情况</td>
              <td class="table-label">内容及形式</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.class_info.content_format"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">课堂氛围</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.class_info.around"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">学员反馈</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.class_info.feedback"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">专家反馈</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.class_info.expert_feedback"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">授课评分</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.class_info.score"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td rowspan="5" class="table-label">后勤管理</td>
              <td class="table-label">住宿</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.logistics.hotel"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">用餐</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.logistics.feed"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">交通</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.logistics.car"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">学员反馈</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.logistics.feedback"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">其他</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.logistics.other"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td rowspan="2" class="table-label">存在问题及<br />解决措施</td>
              <td class="table-label">问题</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.question.issue"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">措施</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.question.answer"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td rowspan="7" class="table-label">
                明日计划及<br />对接落实的<br />情况
              </td>
              <td class="table-label">上午行程</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.tomorrow.am"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">下午行程</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.tomorrow.pm"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">学员住宿</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.tomorrow.hotel"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">学员用餐</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.tomorrow.feed"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">学员交通</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.tomorrow.car"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">场地</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.tomorrow.address"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">专家</td>
              <td colspan="7" class="table-form">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="formData.tomorrow.experts"
                >
                </el-input>
              </td>
            </tr>
            <tr>
              <td class="table-label">课堂照片</td>
              <td colspan="8" class="class-image-box">
                <div class="class-image-operate">
                  <el-button type="primary" size="mini" @click="classImage()"
                    >从班级圈获取</el-button
                  >
                  <dc-upload
                    v-if="dcUploadConfig.key"
                    class="image-uploader"
                    ref="upload"
                    :dcAutoUpload="true"
                    dcdom="uploadProof"
                    :dcConfig="dcUploadConfig"
                    :limit="10"
                    @dc-success="uploadSuccess"
                    :showFileList="false"
                  >
                    <el-button type="primary" size="mini">点击上传</el-button>
                  </dc-upload>
                </div>
                <div>
                  <ul class="public-images-list-1">
                    <li
                      class="images-list-item"
                      v-for="(item, index) in formData.class_image"
                      :key="index"
                    >
                      <el-image
                        :src="item.savepath"
                        :preview-src-list="classImagePreview"
                      >
                      </el-image>
                      <span class="images-delete" @click="imagesDelete(index)">✕</span>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr>
              <td class="table-label">上报领导</td>
              <td colspan="8" class="table-padding-tb">
                <el-select
                  v-model="formData.leader_id"
                  placeholder="选择上报领导"
                  clearable
                  :style="{ width: '100%' }"
                  multiple
                  filterable
                >
                  <el-option
                    v-for="(item, index) in erpUserList"
                    :key="index"
                    :label="item.name"
                    :value="item.erpUserId"
                  ></el-option>
                </el-select>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="daily-operate-box">
          <el-button type="primary" @click="save(1)">保存</el-button>
          <el-button type="primary" @click="save(2)">保存并发送邮件</el-button>
          <el-button type="primary" @click="download()">导出word</el-button>
        </div>
      </el-form>
    </section>
    <ClassImageDialog
      ref="classImageDialog"
      @update="classImageDialogUpdate"
    ></ClassImageDialog>
  </div>
</template>

<script>
import {
  getApiDailyDetails,
  getApiErpUserList,
  putApiDailyDetails,
  postApiDailySendMail,
} from "@/api/tearcher";
import { UPloadFileApi, GetKey_Url } from "@/api/student";
import ClassImageDialog from "@/components/dialog/ClassImageDialog.vue";
export default {
  components: {
    ClassImageDialog,
  },
  data() {
    return {
      loading: true, //是否加载中
      id: 0, //日报id
      dictionary: {}, //全部字典
      dcUploadConfig: {}, //德诚上传配置
      //表单数据
      formData: {
        class_info: {
          content_format: "",
          around: "",
          feedback: "",
          expert_feedback: "",
          score: "",
        },
        schedule_info: {},
        sign: {},
        logistics: {
          hotel: "",
          feed: "",
          car: "",
          feedback: "",
          other: "",
        },
        question: {
          issue: "",
          answer: "",
        },
        tomorrow: {
          am: "",
          pm: "",
          hotel: "",
          feed: "",
          car: "",
          address: "",
          experts: "",
        },
        class_image: [],
        leader_id: [],
      },
      dailyTitle: "", //日报标题
      recordPeople: "", //记录人
      recordDate: "", //记录日期
      classImagePreview: [], //课堂照片预览
      erpUserList: [], //erp用户列表
    };
  },
  methods: {
    //导出word
    download() {
      this.getDailyDetails({ is_export: 1 });
    },
    //保存
    save(type) {
      let formData = JSON.parse(JSON.stringify(this.formData));
      formData.class_info = JSON.stringify(formData.class_info);
      formData.schedule_info = JSON.stringify(formData.schedule_info);
      formData.sign = JSON.stringify(formData.sign);
      formData.logistics = JSON.stringify(formData.logistics);
      formData.question = JSON.stringify(formData.question);
      formData.tomorrow = JSON.stringify(formData.tomorrow);
      formData.class_image = JSON.stringify(formData.class_image);
      formData.leader_id = JSON.stringify(formData.leader_id);

      //保存
      if (type == 1) {
        putApiDailyDetails(this.id, formData).then((res) => {
          if (res.error_code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
              duration: messageDuration,
            });
            this.$router.go(-1);
          }
        });
      }
      //保存并发送邮件
      if (type == 2) {
        if (this.formData.leader_id.length == 0) {
          this.$message({
            message: "请选择上报领导",
            type: "error",
            duration: messageDuration,
          });
          return false;
        }
        putApiDailyDetails(this.id, formData).then((res) => {
          if (res.error_code == 200) {
            let courseInfo = "";
            let classroomImages = ``;

            if (this.formData.schedule_info.list.length != 0) {
              this.formData.schedule_info.list.forEach((item, index) => {
                courseInfo += `
                  <tr>
                    <td colspan="4">${item.title}</td>
                    <td>${item.experts_name}</td>
                `;
                if (index == 0) {
                  courseInfo += `
                    <td rowspan="${this.formData.schedule_info.list.length}">
                      ${this.formData.schedule_info.address}
                    </td>
                  `;
                }
                courseInfo += `
                    <td colspan="2">${item.time}</td>
                  </tr>
                `;
              });
            } else {
              courseInfo += `<tr><td colspan="8">暂无数据</td></tr>`;
            }

            classroomImages += `
              <tr>
                <td class="table-label">课堂照片</td>
                  <td colspan="8" class="class-image-box">
                    <ul class="public-images-list-1">
            `;
            if (this.formData.class_image.length != 0) {
              this.formData.class_image.forEach((item) => {
                classroomImages += `
                  <li class="images-list-item">
                    <img src="${item.savepath}" class="item-images"/>
                  </li>
                `;
              });
            }
            classroomImages += `
                    </ul>
                  </td>
              </tr>
            `;

            let html = `
              <div>
                <h3 class="daily-title">${this.dailyTitle}</h3>
                <table class="table-body">
                  <thead>
                    <tr>
                      <th colspan="9">
                        <div class="table-flex">
                          <p class="table-text-1">记录人：${this.recordPeople}</p>
                          <p class="table-text-1">记录日期：${this.recordDate}</p>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        rowspan="${this.formData.schedule_info.list.length + 1}"
                        class="table-label"
                      >
                        课程信息
                      </td>
                      <td colspan="4" class="table-label">课程名称</td>
                      <td class="table-label">授课专家</td>
                      <td class="table-label">地点</td>
                      <td colspan="2" class="table-label">时间</td>
                    </tr>
                    ${courseInfo}
                    <tr>
                      <td rowspan="3" class="table-label">考勤情况</td>
                      <td class="table-label">上午应到</td>
                      <td class="table-statistics">
                        <div class="table-statistics-box">
                          <div class="table-statistics-value">
                            ${this.formData.sign.am.should_count}
                          </div>
                          <div class="table-statistics-label">人</div>
                        </div>
                      </td>
                      <td class="table-label">上午实到</td>
                      <td class="table-statistics">
                        <div class="table-statistics-box">
                          <div class="table-statistics-value">
                            ${this.formData.sign.am.ct_num}
                          </div>
                          <div class="table-statistics-label">人</div>
                        </div>
                      </td>
                      <td class="table-label">上午迟到</td>
                      <td class="table-statistics">
                        <div class="table-statistics-box">
                          <div class="table-statistics-value">
                            ${this.formData.sign.am.late_num}
                          </div>
                          <div class="table-statistics-label">人</div>
                        </div>
                      </td>
                      <td class="table-label">上午请假</td>
                      <td class="table-statistics">
                        <div class="table-statistics-box">
                          <div class="table-statistics-value">
                            ${this.formData.sign.am.leave_num}
                          </div>
                          <div class="table-statistics-label">人</div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">下午应到</td>
                      <td class="table-statistics">
                        <div class="table-statistics-box">
                          <div class="table-statistics-value">
                            ${this.formData.sign.pm.should_count}
                          </div>
                          <div class="table-statistics-label">人</div>
                        </div>
                      </td>
                      <td class="table-label">下午实到</td>
                      <td class="table-statistics">
                        <div class="table-statistics-box">
                          <div class="table-statistics-value">
                            ${this.formData.sign.pm.ct_num}
                          </div>
                          <div class="table-statistics-label">人</div>
                        </div>
                      </td>
                      <td class="table-label">下午迟到</td>
                      <td class="table-statistics">
                        <div class="table-statistics-box">
                          <div class="table-statistics-value">
                            ${this.formData.sign.pm.late_num}
                          </div>
                          <div class="table-statistics-label">人</div>
                        </div>
                      </td>
                      <td class="table-label">下午请假</td>
                      <td class="table-statistics">
                        <div class="table-statistics-box">
                          <div class="table-statistics-value">
                            ${this.formData.sign.pm.leave_num}
                          </div>
                          <div class="table-statistics-label">人</div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="8" class="table-form">
                        ${this.formData.sign.out_user}
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="5" class="table-label">课堂情况</td>
                      <td class="table-label">内容及形式</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.class_info.content_format}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">课堂氛围</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.class_info.around}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">学员反馈</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.class_info.feedback}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">专家反馈</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.class_info.expert_feedback}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">授课评分</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.class_info.score}
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="5" class="table-label">后勤管理</td>
                      <td class="table-label">住宿</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.logistics.hotel}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">用餐</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.logistics.feed}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">交通</td>
                      <td colspan="7" class="table-form">${
                        this.formData.logistics.car
                      }</td>
                    </tr>
                    <tr>
                      <td class="table-label">学员反馈</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.logistics.feedback}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">其他</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.logistics.other}
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2" class="table-label">存在问题及<br />解决措施</td>
                      <td class="table-label">问题</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.question.issue}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">措施</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.question.answer}
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="7" class="table-label">
                        明日计划及<br />对接落实的<br />情况
                      </td>
                      <td class="table-label">上午行程</td>
                      <td colspan="7" class="table-form">${this.formData.tomorrow.am}</td>
                    </tr>
                    <tr>
                      <td class="table-label">下午行程</td>
                      <td colspan="7" class="table-form">${this.formData.tomorrow.pm}</td>
                    </tr>
                    <tr>
                      <td class="table-label">学员住宿</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.tomorrow.hotel}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">学员用餐</td>
                      <td colspan="7" class="table-form">${
                        this.formData.tomorrow.feed
                      }</td>
                    </tr>
                    <tr>
                      <td class="table-label">学员交通</td>
                      <td colspan="7" class="table-form">${
                        this.formData.tomorrow.car
                      }</td>
                    </tr>
                    <tr>
                      <td class="table-label">场地</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.tomorrow.address}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-label">专家</td>
                      <td colspan="7" class="table-form">
                        ${this.formData.tomorrow.experts}
                      </td>
                    </tr>
                    ${classroomImages}
                  </tbody>
                </table>
              </div>


              <style>
                .daily-title {
                  font-size: 24px;
                  font-weight: bold;
                  color: #333333;
                  text-align: center;
                  margin-bottom: 30px;
                }

                .table-body {
                  width: 100%;
                  border-collapse: collapse;
                  border-spacing: 0;
                  border: 1px solid #dcdfe6;
                  margin-bottom: 25px;
                }

                .table-body tr,
                .table-body th,
                .table-body td {
                  border: 1px solid #dcdfe6;
                }

                .table-body th,
                .table-body td {
                  height: 46px;
                  font-size: 14px;
                  color: #333333;
                  text-align: center;
                  padding: 0 25px !important;
                }

                .table-body th {
                  color: #666666;
                }

                .table-body .table-flex {
                  display: flex;
                  justify-content: space-between;
                }

                .table-body .table-text-1 {
                  font-size: 15px;
                  font-weight: bold;
                  color: #333333;
                }

                .table-body .table-label {
                  font-size: 15px;
                  font-weight: bold;
                  color: #333333;
                  white-space: nowrap;
                  background: #f6f8fa;
                }

                .table-body .table-statistics {
                  width: 100px;
                  padding: 0 !important;
                }

                .table-body .table-statistics .table-statistics-box {
                  height: 100%;
                  display: flex;
                  align-items: center;
                }

                .table-body .table-statistics .table-statistics-box .table-statistics-value {
                  flex: 1;
                }

                .table-body .table-statistics .table-statistics-box .table-statistics-label {
                  height: 100%;
                  padding: 0 10px;
                  background: #f9f9f9;
                  display: flex;
                  align-items: center;
                }

                .table-body .table-padding-tb {
                  padding-top: 20px;
                  padding-bottom: 20px;
                }

                .table-body .unit-table-orange {
                  color: #e6690f;
                  background: #ffdec6;
                }

                .table-body .unit-table-green {
                  color: #638b38;
                  background: #cfe9b3;
                }

                .table-body .unit-table-purple {
                  color: #6c52ae;
                  background: #cabded;
                }

                .table-body .unit-table-width-130 {
                  width: 130px;
                }

                .table-body .unit-table-width-95 {
                  width: 95px;
                }

                .table-body .unit-table-input {
                  padding: 0 15px;
                }

                .flex-align-center {
                  display: flex;
                  align-items: center;
                }

                .table-body tr .class-image-box {
                  text-align: left;
                  padding: 20px 20px 0 20px !important;
                }

                .public-images-list-1 {
                  display: flex;
                  flex-wrap: wrap;
                  list-style-type: none !important;
                  padding-left: 0 !important;
                }

                .public-images-list-1 .images-list-item {
                  width: 134px;
                  height: 75px;
                  margin: 0 20px 20px 0;
                }

                .public-images-list-1 .images-list-item .item-images {
                  width: 100%;
                  height: 100%;
                  border-radius: 4px;
                  overflow: hidden;
                }
              </style>
            `;

            let params = {
              title: `蓝天小研日报-${this.recordPeople}-${this.recordDate}`,
              content: html,
              receiveId: this.formData.leader_id.join(","),
              class_report_id: this.id,
            };
            postApiDailySendMail(params).then((res) => {
              if (res.error_code == 200) {
                this.$message({
                  message: res.msg,
                  type: "success",
                  duration: messageDuration,
                });
                this.$router.go(-1);
              }
            });
          }
        });
      }
    },
    //从班级圈获取
    classImage() {
      this.$refs["classImageDialog"].open();
    },
    //班级圈弹窗回调
    classImageDialogUpdate(list) {
      this.formData.class_image = this.formData.class_image.concat(list);
      this.setClassImagePreview();
    },
    //设置课堂照片预览
    setClassImagePreview() {
      this.classImagePreview = this.formData.class_image.map((item) => {
        return item.savepath;
      });
    },
    //获取erp用户列表
    getErpUserList() {
      getApiErpUserList().then((res) => {
        if (res.error_code == 200) {
          this.erpUserList = res.data;
        }
      });
    },
    //获取日报详情
    getDailyDetails(e = {}) {
      getApiDailyDetails(this.id, e).then((res) => {
        if (res.error_code == 200) {
          let data = res.data;

          //下载日报word
          if (e.hasOwnProperty("is_export")) {
            window.open(data);
            return false;
          }

          this.dailyTitle = data.title;
          this.recordPeople = data.truename;
          this.recordDate = data.start_date_name;

          this.formData.schedule_info = data.schedule_info;
          this.formData.sign = data.sign;
          this.formData.class_info = data.class_info;
          this.formData.logistics = data.logistics;
          this.formData.question = data.question;
          this.formData.tomorrow = data.tomorrow;
          this.formData.class_image = data.class_image;
          this.formData.leader_id = data.leader_id;
          this.setClassImagePreview();

          this.loading = false;
        }
      });
    },
    //获取德诚上传配置
    getDcUploadConfig() {
      GetKey_Url().then((res) => {
        this.dcUploadConfig = res.data;
      });
    },
    //课堂照片上传成功回调
    uploadSuccess(data) {
      let etag = data.upload.CompleteMultipartUploadResult.ETag;
      //去掉字符串的双引号
      etag = etag.replace(/"/g, "");
      UPloadFileApi({ etag }).then((res) => {
        const data = res.data;
        const params = {
          id: data.id,
          savename: data.savename,
          savepath: data.savepath,
        };
        this.formData.class_image.push(params);
        this.setClassImagePreview();
      });
    },
    //课堂照片删除文件
    imagesDelete(index) {
      this.formData.class_image.splice(index, 1);
      this.classImagePreview.splice(index, 1);
    },
  },
  created() {
    const query = this.$route.query;
    this.id = query.id;
    this.dictionary = JSON.parse(localStorage.getItem("dictionary")); //获取全部字典
    this.getDcUploadConfig();
    this.getErpUserList();
    this.getDailyDetails();
  },
};
</script>

<style lang="less" scoped>
.daily-title {
  font-size: 24px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin-bottom: 30px;
}
.table-body {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #dcdfe6;
  margin-bottom: 25px;

  tr,
  th,
  td {
    border: 1px solid #dcdfe6;
  }

  th,
  td {
    height: 46px;
    font-size: 14px;
    color: #333333;
    text-align: center;
    padding: 0 25px;
  }

  th {
    color: #666666;
  }

  .table-flex {
    display: flex;
    justify-content: space-between;
  }

  .table-text-1 {
    font-size: 15px;
    font-weight: bold;
    color: #333333;
  }

  .table-label {
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    background: #f6f8fa;
  }

  .table-statistics {
    width: 100px;
    padding: 0;
    .table-statistics-box {
      height: 100%;
      display: flex;
      align-items: center;
      .table-statistics-value {
        flex: 1;
      }
      .table-statistics-label {
        height: 100%;
        padding: 0 10px;
        background: #f9f9f9;
        display: flex;
        align-items: center;
      }
    }
  }

  .table-padding-tb {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .table-form {
    padding: 0;
    /deep/.el-textarea__inner {
      border: 0;
    }
  }

  .unit-table-orange {
    color: #e6690f;
    background: #ffdec6;
  }

  .unit-table-green {
    color: #638b38;
    background: #cfe9b3;
  }

  .unit-table-purple {
    color: #6c52ae;
    background: #cabded;
  }

  .unit-table-width-130 {
    width: 130px;
  }

  .unit-table-width-95 {
    width: 95px;
  }

  .unit-table-input {
    padding: 0 15px;
  }

  .el-form-item {
    margin-bottom: 0;
  }
}
.flex-align-center {
  display: flex;
  align-items: center;
}
.class-image-box {
  text-align: left !important;
  padding: 25px !important;
  .class-image-operate {
    display: flex;
    .el-button {
      margin-right: 25px;
    }
  }
}
.daily-operate-box {
  padding: 25px;
  display: flex;
  justify-content: center;
}
</style>
